import { PlotData } from "controls/plot/graph-plot/GraphPlot";
import {
    NarrowbandSelectionMode,
    NarrowbandSelectionModes,
} from "modules/workflows/Analysis/Spectrum/SpectrumModuleModes";
import { SelectableRange } from "./FrequencySelectionService";
import { SpectralMaxFinder } from "./SpectralMaxFinder";

type FrequencySelectionStrategy = (spectra: PlotData[], ranges: SelectableRange[]) => number | null;

// Ranges are always stored in Hz by FrequencySelectionService.
// SpectralMaxFinder handles unit conversion internally.
const maxBandStrategy: FrequencySelectionStrategy = (spectra, ranges) => {
    const selectedRanges = ranges.filter((range) => range.isSelected);
    if (selectedRanges.length === 0 || spectra.length === 0) return null;

    return SpectralMaxFinder.findMaxFrequencyInRanges(spectra, selectedRanges);
};

const centerStrategy: FrequencySelectionStrategy = (spectra, ranges) => {
    const selectedRanges = ranges.filter((range) => range.isSelected);
    if (selectedRanges.length === 0) return null;

    const centerFrequencies = selectedRanges.map((range) => (range.from + range.to) / 2);

    // If multiple ranges are selected, return the highest center frequency (usually best case for holography/beamforming)
    return Math.max(...centerFrequencies);
};

const noneStrategy: FrequencySelectionStrategy = (spectra, ranges) => {
    return null;
};
export const FrequencySelectionStrategies: Record<NarrowbandSelectionMode, FrequencySelectionStrategy> = {
    [NarrowbandSelectionModes.maxBand]: maxBandStrategy,
    [NarrowbandSelectionModes.centerBand]: centerStrategy,
    [NarrowbandSelectionModes.none]: noneStrategy,
} as const;
